import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Instructor, InstructorDto, InstructorValue, InstructorValueDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getInstructor(id: string): Observable<Instructor> {
        return this.httpClient.get<InstructorDto>(`instructors/${id}`).pipe(map((dto) => new Instructor(dto)));
    }

    createInstructor(value: InstructorValue): Observable<Instructor> {
        const dto = new InstructorValueDto(value);

        return this.httpClient.post<InstructorDto>('instructors', dto).pipe(map((response) => new Instructor(response)));
    }

    updateInstructor(id: string, value: InstructorValue): Observable<Instructor> {
        const dto = new InstructorValueDto(value);

        return this.httpClient.patch<InstructorDto>(`instructors/${id}`, dto).pipe(map((response) => new Instructor(response)));
    }

    deleteInstructor(id: string): Observable<void> {
        return this.httpClient.delete<void>(`instructors/${id}`);
    }
}
